import type { AxiosError } from 'axios';
import { format } from 'date-fns';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Customer } from './types';

type Variables = { firstName: string; lastName: string; dob: Date };
type Response = Customer;

export const useCustomer = createQuery<Response, Variables, AxiosError>({
  queryKey: ['customers/me'],
  fetcher: () => {
    return client.get('v2/customers/me').then((response) => {
      const data = { ...response.data.data };

      if (response.data.data?.dob) {
        const [year, month, day] = response.data.data.dob.split('-');

        const parsedDate = new Date(
          parseInt(year, 10),
          parseInt(month, 10) - 1, // Month is 0-based in JavaScript
          parseInt(day, 10)
        );

        const formattedDateString = format(parsedDate, 'MM/dd/yyyy');

        data.dob = formattedDateString;
      }

      return data;
    });
  },
});
